import { render, staticRenderFns } from "./AccountLogin.vue?vue&type=template&id=72b6c7b8&scoped=true&"
import script from "./AccountLogin.vue?vue&type=script&lang=js&"
export * from "./AccountLogin.vue?vue&type=script&lang=js&"
import style0 from "./AccountLogin.vue?vue&type=style&index=0&id=72b6c7b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b6c7b8",
  null
  
)

export default component.exports